var _style, _symbol, _path, _path2, _defs, _path3, _defs2, _path4, _defs3, _path5, _defs4, _defs5, _g, _g2, _g3, _defs6, _g4, _g5, _rect, _g6, _defs7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmile = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 13 13",
  style: {
    enableBackground: "new 0 0 13 13"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke:#4285F4;stroke-miterlimit:10;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#EB8F00;}\n\t.st3{clip-path:url(#SVGID_3_);fill:#242424;}\n\t.st4{clip-path:url(#SVGID_5_);fill:#FFFFFF;}\n\t.st5{clip-path:url(#SVGID_7_);fill:#ED7770;}\n\t.st6{clip-path:url(#SVGID_9_);}\n\t.st7{clip-path:url(#SVGID_11_);}\n\t.st8{fill:#242424;}\n\t.st9{display:none;}\n\t.st10{display:inline;}\n\t.st11{opacity:0.6;}\n\t.st12{opacity:0.61;fill:none;stroke:#000000;stroke-width:0.2625;stroke-miterlimit:10;enable-background:new    ;}\n\t.st13{opacity:0.61;fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;enable-background:new    ;}\n\t.st14{opacity:0.61;}\n\t.st15{opacity:0.61;fill:none;stroke:#000000;stroke-width:0.2578;stroke-miterlimit:10;enable-background:new    ;}\n\t.st16{opacity:0.61;fill:none;stroke:#000000;stroke-width:0.2628;stroke-miterlimit:10;enable-background:new    ;}\n\t.st17{opacity:0.61;fill:none;stroke:#000000;stroke-width:0.2627;stroke-miterlimit:10;enable-background:new    ;}\n\t.st18{opacity:0.2;}\n\t.st19{clip-path:url(#SVGID_13_);}\n\t.st20{fill:none;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st21{opacity:0.3;fill:#F44336;enable-background:new    ;}\n\t.st22{display:inline;fill:none;stroke:#616161;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st23{fill:none;stroke:#E0E0E0;stroke-width:0.25;stroke-miterlimit:10;}\n")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
  id: "Grid",
  viewBox: "-64.5 -64.5 129 129"
}, /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1_"
}, /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_10_",
  x: -64,
  y: -64,
  className: "st0",
  width: 128,
  height: 128
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_8_",
  className: "st0",
  d: "M37,37.8C27.3,46.3,14.2,51,0,51c-14.3,0-27.4-4.6-37-13c-10.5-9.2-16-22.3-16-38 c0-15.6,5.5-28.7,16-37.9C-27.4-46.3-14.2-51,0-51c14.2,0,27.3,4.7,37,13.2C47.5-28.5,53-15.4,53,0C53,15.5,47.5,28.5,37,37.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_7_",
  className: "st0",
  d: "M0,55L0,55L0,55c-29.6,0-57-19-57-55c0-35.8,27.4-55,57-55l0,0l0,0c29.6,0,57,19.7,57,55 C57,35.5,29.6,55,0,55z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_6_",
  className: "st0",
  d: "M0-43c-12.3,0-23.5,3.9-31.7,11.1C-40.4-24.2-45-13.2-45,0c0,29.7,22.6,43,45,43 c21.7,0,45-13.5,45-43S21.7-43,0-43L0-43z"
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_5_",
  className: "st0",
  x1: 0,
  y1: 51,
  x2: 0,
  y2: -51
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_4_",
  className: "st0",
  x1: -16,
  y1: 49,
  x2: -16,
  y2: -48.9
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_3_",
  className: "st0",
  x1: 16,
  y1: 48.9,
  x2: 16,
  y2: -48.9
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_2_",
  className: "st0",
  x1: 53,
  y1: 0.1,
  x2: -53,
  y2: 0.1
})))), /*#__PURE__*/React.createElement("g", {
  id: "Layer_1_1_"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 6.5,
  y1: 12.0169,
  x2: 6.5,
  y2: 5.0293,
  gradientTransform: "matrix(1 0 0 -1 0 15)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  style: {
    stopColor: "#FEE133"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6118,
  style: {
    stopColor: "#FEDE32"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7076,
  style: {
    stopColor: "#FCD32F"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7975,
  style: {
    stopColor: "#FAC12B"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8834,
  style: {
    stopColor: "#F7A924"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9,
  style: {
    stopColor: "#F6A323"
  }
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M6.5,10.9c-2.2,0-4.6-1.4-4.6-4.4s2.4-4.4,4.6-4.4c1.2,0,2.4,0.4,3.2,1.1c0.9,0.8,1.4,1.9,1.4,3.3 c0,1.3-0.5,2.5-1.4,3.3C8.9,10.5,7.7,10.9,6.5,10.9z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M6.5,2.2L6.5,2.2c1.2,0,2.3,0.4,3.1,1.1c0.9,0.8,1.3,1.9,1.3,3.2c0,1.3-0.5,2.4-1.3,3.2 c-0.8,0.7-1.9,1.1-3.1,1.1c-1.2,0-2.3-0.4-3.1-1.1C2.5,8.9,2.1,7.8,2.1,6.5c0-1.3,0.5-2.4,1.3-3.2C4.2,2.6,5.3,2.2,6.5,2.2  M6.5,1.9L6.5,1.9L6.5,1.9L6.5,1.9C4,1.9,1.7,3.5,1.7,6.5c0,3,2.3,4.6,4.8,4.6l0,0l0,0l0,0c2.5,0,4.8-1.6,4.8-4.6 C11.3,3.5,9,1.9,6.5,1.9L6.5,1.9z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_2_",
  d: "M6.5,6.4c-1.2,0-2.4-0.1-3.4-0.3c-0.2,0-0.5,0.2-0.4,0.4C3,8.1,4.6,9.4,6.5,9.4c2.1,0,3.5-1.3,3.8-2.9 c0-0.2-0.2-0.4-0.4-0.4C8.9,6.3,7.7,6.4,6.5,6.4z"
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_3_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_2_",
  style: {
    overflow: "visible"
  }
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M6.5,6.4c-1.2,0-2.4-0.1-3.4-0.3c-0.2,0-0.5,0.2-0.4,0.4C3,8.1,4.6,9.4,6.5,9.4c2.1,0,3.5-1.3,3.8-2.9 c0-0.2-0.2-0.4-0.4-0.4C8.9,6.3,7.7,6.4,6.5,6.4z"
}))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_4_",
  d: "M6.5,6.4c-1.2,0-2.4-0.1-3.4-0.3c-0.2,0-0.5,0.2-0.4,0.4C3,8.1,4.6,9.4,6.5,9.4c2.1,0,3.5-1.3,3.8-2.9 c0-0.2-0.2-0.4-0.4-0.4C8.9,6.3,7.7,6.4,6.5,6.4z"
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_5_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_4_",
  style: {
    overflow: "visible"
  }
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M10.7,6.3V5.1H2.2v1.2C3.5,7.1,5,7.5,6.5,7.5S9.4,7.1,10.7,6.3z"
}))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_6_",
  d: "M6.5,6.4c-1.2,0-2.4-0.1-3.4-0.3c-0.2,0-0.5,0.2-0.4,0.4C3,8.1,4.6,9.4,6.5,9.4c2.1,0,3.5-1.3,3.8-2.9 c0-0.2-0.2-0.4-0.4-0.4C8.9,6.3,7.7,6.4,6.5,6.4z"
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_7_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_6_",
  style: {
    overflow: "visible"
  }
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M6.5,8.3c-0.9,0-1.8,0.5-2.2,1.3C4.8,9.9,5.6,10,6.5,10s1.6-0.2,2.2-0.5C8.2,8.8,7.4,8.3,6.5,8.3z"
}))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_8_",
  d: "M6.5,6.4c-1.2,0-2.4-0.1-3.4-0.3c-0.2,0-0.5,0.2-0.4,0.4C3,8.1,4.6,9.4,6.5,9.4c2.1,0,3.5-1.3,3.8-2.9 c0-0.2-0.2-0.4-0.4-0.4C8.9,6.3,7.7,6.4,6.5,6.4z"
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_9_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_8_",
  style: {
    overflow: "visible"
  }
})), /*#__PURE__*/React.createElement("g", {
  className: "st6"
}, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_10_",
  d: "M2.2,5.1v1.2C3.5,7.1,5,7.5,6.5,7.5s2.9-0.4,4.2-1.2V5.1H2.2z M6.5,8.3c-0.9,0-1.8,0.5-2.2,1.3 C4.8,9.9,5.6,10,6.5,10c0.9,0,1.6-0.2,2.2-0.5C8.2,8.8,7.4,8.3,6.5,8.3z"
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_11_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_10_",
  style: {
    overflow: "visible"
  }
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "st7"
}, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M9.9,6.4C9.9,6.4,9.9,6.4,9.9,6.4C9.8,7.1,9.4,7.8,8.8,8.3C8.2,8.8,7.4,9,6.5,9C5.6,9,4.8,8.8,4.2,8.3 C3.6,7.8,3.2,7.1,3,6.4c0,0,0,0,0,0h0c1,0.2,2.2,0.3,3.4,0.3S8.9,6.6,9.9,6.4C9.9,6.4,9.9,6.4,9.9,6.4 M9.9,6.1 C9.9,6.1,9.9,6.1,9.9,6.1c-1,0.2-2.2,0.3-3.4,0.3c-1.2,0-2.4-0.1-3.4-0.3c0,0,0,0-0.1,0c-0.2,0-0.4,0.2-0.3,0.4 C3,8.1,4.6,9.4,6.5,9.4c2.1,0,3.5-1.3,3.8-2.9C10.3,6.3,10.1,6.1,9.9,6.1L9.9,6.1z"
}))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M5.3,5.2C5.3,5.2,5.3,5.2,5.3,5.2C5.3,5.1,5.3,5.1,5.3,5.2C5.2,5.1,5.2,5.1,5.2,5c0,0,0,0-0.1-0.1 c0,0,0,0-0.1-0.1c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0h0h0h0l0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1l0,0 C4.4,5.3,4.2,5.3,4,5.2C3.9,5.2,3.9,5,3.9,4.9c0,0,0,0,0-0.1c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1-0.2,0.3-0.3 c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0l0.1,0c0,0,0,0,0,0l0,0l0,0h0h0l0,0l0,0l0,0c0,0,0.1,0,0.1,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.3,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1 c0,0,0,0,0,0c0,0.2-0.1,0.3-0.3,0.4C5.5,5.3,5.4,5.2,5.3,5.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M8.4,5.2C8.4,5.2,8.4,5.2,8.4,5.2C8.4,5.1,8.4,5.1,8.4,5.2C8.4,5.1,8.4,5.1,8.3,5c0,0,0,0-0.1-0.1 c0,0,0,0-0.1-0.1c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0h0h0h0l0,0l0,0c0,0,0,0,0,0l0,0c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1l0,0 C7.5,5.3,7.3,5.3,7.2,5.2C7.1,5.2,7,5,7.1,4.9c0,0,0,0,0-0.1c0-0.1,0-0.1,0.1-0.2c0.1-0.1,0.1-0.2,0.3-0.3 c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0l0.1,0c0,0,0,0,0,0l0,0l0,0h0h0l0,0l0,0l0,0c0,0,0.1,0,0.1,0 c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0.1,0.3,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1 c0,0,0,0,0,0c0,0.2-0.1,0.3-0.3,0.4C8.6,5.3,8.5,5.2,8.4,5.2z"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "Layer_2_1_",
  className: "st9"
}, /*#__PURE__*/React.createElement("g", {
  className: "st10"
}, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  className: "st11"
}, /*#__PURE__*/React.createElement("line", {
  className: "st13",
  x1: 121.5,
  y1: 6.5,
  x2: -6.5,
  y2: 6.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st13",
  x1: 121.5,
  y1: 70.5,
  x2: -6.5,
  y2: -57.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st13",
  x1: -6.5,
  y1: 70.5,
  x2: 121.5,
  y2: -57.5
}), /*#__PURE__*/React.createElement("g", {
  className: "st14"
}, /*#__PURE__*/React.createElement("path", {
  d: "M57.5-53.2c32.9,0,59.7,26.8,59.7,59.7S90.4,66.2,57.5,66.2S-2.2,39.4-2.2,6.5S24.6-53.2,57.5-53.2 M57.5-53.5 c-33.1,0-60,26.9-60,60s26.9,60,60,60s60-26.9,60-60S90.6-53.5,57.5-53.5L57.5-53.5z"
})), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M101.5,58.5H13.5c-4.4,0-8-3.6-8-8v-87.9c0-4.4,3.6-8,8-8h87.9c4.4,0,8,3.6,8,8v87.9 C109.5,54.9,105.9,58.5,101.5,58.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M107.3,50.5H7.7c-5.6,0-10.2-4.6-10.2-10.2v-67.5c0-5.6,4.6-10.2,10.2-10.2h99.5c5.6,0,10.2,4.6,10.2,10.2 v67.5C117.5,45.9,112.9,50.5,107.3,50.5z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  className: "st18"
}, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_12_",
  x: -6.5,
  y: -57.5,
  width: 128,
  height: 128
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_13_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_12_",
  style: {
    overflow: "visible"
  }
})), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  className: "st19"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st20",
  x1: 1.5,
  y1: 102.5,
  x2: 1.5,
  y2: -89.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st20",
  x1: 5.5,
  y1: 102.5,
  x2: 5.5,
  y2: -89.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st20",
  x1: 9.5,
  y1: 102.5,
  x2: 9.5,
  y2: -89.5
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st20",
  x1: -38.5,
  y1: 2.5,
  x2: 153.5,
  y2: 2.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st20",
  x1: -38.5,
  y1: 6.5,
  x2: 153.5,
  y2: 6.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st20",
  x1: -38.5,
  y1: 10.5,
  x2: 153.5,
  y2: 10.5
})), /*#__PURE__*/React.createElement("path", {
  d: "M153.2-89.2v191.5H-38.2V-89.2H153.2 M153.5-89.5h-192v192h192V-89.5L153.5-89.5z"
}))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null))))), /*#__PURE__*/React.createElement("g", {
  id: "Layer_3",
  className: "st9"
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_46_",
  x: -6.5,
  y: -57.5,
  className: "st22",
  width: 128,
  height: 128
})), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_9_",
  className: "st10"
}, /*#__PURE__*/React.createElement("rect", {
  id: "XMLID_45_",
  x: -6.5,
  y: -57.5,
  className: "st23",
  width: 128,
  height: 128
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_44_",
  className: "st23",
  x1: 1.5,
  y1: -57.5,
  x2: 1.5,
  y2: 70.5
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_43_",
  className: "st23",
  x1: 9.5,
  y1: -57.5,
  x2: 9.5,
  y2: 70.5
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_56_",
  className: "st23",
  x1: 121.5,
  y1: 6.5,
  x2: -6.5,
  y2: 6.5
}))), /*#__PURE__*/React.createElement("g", {
  className: "st10"
}, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "SVGID_14_",
  x: -7,
  y: -58,
  width: 129,
  height: 129
}))), /*#__PURE__*/React.createElement("clipPath", {
  id: "SVGID_15_"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#SVGID_14_",
  style: {
    overflow: "visible"
  }
})), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#SVGID_15_)"
  }
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Grid",
  width: 129,
  height: 129,
  id: "XMLID_31_",
  x: -64.5,
  y: -64.5,
  transform: "matrix(1 0 0 -1 57.5 6.5)",
  style: {
    overflow: "visible"
  }
})))));
export default SvgSmile;